export default __webpack_public_path__ + "static/radovi5-8bd712fc17fbbeac795ff14430232872.png";